export default __webpack_public_path__ + "static/media/landscape7.234d14ca.jpg";